import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createAimsDocumentType,
  deleteAimsDocumentType,
  getAimsDocumentType,
  getAimsDocumentTypes,
  getAimsDocumentTypesMasterData,
  updateAimsDocumentType
} from '../../../api/aims-document-types';

export const getAimsDocumentTypesAsync = createAsyncThunk(
  'aimsDocumentTypes/getAimsDocumentTypes',
  getAimsDocumentTypes
);

export const getAimsDocumentTypesMasterDataAsync = createAsyncThunk(
  'aimsDocumentTypes/getAimsDocumentTypesMasterData',
  getAimsDocumentTypesMasterData
);

export const getAimsDocumentTypeAsync = createAsyncThunk(
  'aimsDocumentTypes/getAimsDocumentType',
  getAimsDocumentType
);

export const createAimsDocumentTypeAsync = createAsyncThunk(
  'aimsDocumentTypes/createAimsDocumentType',
  createAimsDocumentType
);

export const updateAimsDocumentTypeAsync = createAsyncThunk(
  'aimsDocumentTypes/updateAimsDocumentType',
  updateAimsDocumentType
);

export const deleteAimsDocumentTypeAsync = createAsyncThunk(
  'aimsDocumentTypes/deleteAimsDocumentType',
  deleteAimsDocumentType
);

export interface AimsDocumentType {
  id: number;
  name: string;
}

interface AimsDocumentTypeState {
  data: AimsDocumentType[];
  masterData: AimsDocumentType[];
  count: number;
  selectedAimsDocumentType: AimsDocumentType | null;
}

const initialState: AimsDocumentTypeState = {
  data: [],
  masterData: [],
  count: 0,
  selectedAimsDocumentType: null
};

export default createSlice({
  name: 'aimsDocumentTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAimsDocumentTypesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getAimsDocumentTypesMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getAimsDocumentTypeAsync.fulfilled, (state, action) => {
      state.selectedAimsDocumentType = action.payload;
    });
  }
});
